// extracted by mini-css-extract-plugin
module.exports = {"checkmarkWrap":"SelectedProduct_checkmarkWrap__1d-wU"};